import { Box, Chip } from '@mui/material'
import type { ReactNode } from 'react'
import { MESSAGES } from '~/components/Charts/chrome/chartChrome'

interface Props {
  /** True while the kept (previous-key) data is on screen and a new fetch is in flight. */
  active: boolean
  children: ReactNode
}

/**
 * Refetch cue: while `active`, dims the kept chart and overlays an "Updating…" chip, and
 * marks the wrapper aria-busy. When inactive it is a transparent passthrough. Pure
 * presentational. Pair with placeholderData: keepPreviousData on the backing data hook.
 */
export function PendingOverlay({ active, children }: Props) {
  if (!active) return <>{children}</>
  return (
    <Box sx={{ position: 'relative' }} aria-busy>
      <Box sx={{ opacity: 0.5, pointerEvents: 'none' }}>{children}</Box>
      <Chip
        label={MESSAGES.chartUpdating}
        size="small"
        sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
      />
    </Box>
  )
}
